import {__} from "@wordpress/i18n";

/** Options for select fields */
export const MAC_ES_OPTIONS = {
    region: [
        {value: "ANDALUCIA", label: __("Andalucia", "df-simulators")},
        {value: "ARAGON", label: __("Aragón", "df-simulators")},
        {value: "ASTURIAS", label: __("Asturias", "df-simulators")},
        {value: "CANARIAS", label: __("Canarias", "df-simulators")},
        {value: "CANTABRIA", label: __("Cantabria", "df-simulators")},
        {value: "CASTILLA_LA_MANCHA", label: __("Castilla la Mancha", "df-simulators")},
        {value: "CASTILLA_Y_LEON", label: __("Castilla y León", "df-simulators")},
        {value: "CATALUNA", label: __("Catalunya", "df-simulators")},
        {value: "CEUTA", label: __("Ceuta", "df-simulators")},
        {value: "COMUNITAT_VALENCIANA", label: __("Comunitat Valenciana", "df-simulators")},
        {value: "EXTREMADURA", label: __("Extremadura", "df-simulators")},
        {value: "GALICIA", label: __("Galicía", "df-simulators")},
        {value: "ILLES_BALEARS", label: __("Illes Balears", "df-simulators")},
        {value: "LA_RIOJA", label: __("La Rioja", "df-simulators")},
        {value: "MADRID", label: __("Madrid", "df-simulators")},
        {value: "MELILLA", label: __("Melilla", "df-simulators")},
        {value: "MURCIA", label: __("Murcia", "df-simulators")},
        {value: "NAVARRA", label: __("Navarra", "df-simulators")},
        {value: "PAIS_VASCO", label: __("País Vasco", "df-simulators")},
    ],
    propertyCondition: [
        {value: "USADA", label: __("Usada", "df-simulators")},
        {value: "NUEVA", label: __("Nova", "df-simulators")},
    ],
    rateType: [
        {value: "FIXED", label: __("Fixa", "df-simulators")},
        {value: "VARIABLE", label: __("Variável", "df-simulators")},
    ],
};

/** Constants for i18n labels */
export const MAC_ES_LABELS = {
    titleProperty: __("Dados para a simulação", "df-simulators"),
    region: __("Região", "df-simulators"),
    propertyCondition: __("Condição do imóvel", "df-simulators"),
    customerAge: __("Idade", "df-simulators"),
    monthlyNetIncome: __("Rendimento Mensal Líquido", "df-simulators"),
    monthlyLoanExpenses: __("Despesas mensais com outros créditos", "df-simulators"),
    initialCapital: __("Capitais próprios", "df-simulators"),
    equityDownAmount: __("Capitais próprios disponíveis", "df-simulators"),
    loanTermInYears: __("Prazo do empréstimo (anos)", "df-simulators"),
    years: __("Anos", "df-simulators"),
    rateType: __("Tipo de taxa de juro", "df-simulators"),
};
